import {
  Award,
  Bell,
  BellRing,
  Gift,
  Heart,
  MessageCircle,
  Reply,
  Send,
  TrendingUp,
  UserPlus,
  Users,
} from 'lucide-react';

export const NOTIFICATION_ICONS = {
  reaction: <Heart className="h-4 w-4 text-pink-500" />,
  comment: <MessageCircle className="h-4 w-4 text-blue-500" />,
  comment_reaction: <Heart className="h-4 w-4 text-pink-500" />,
  comment_reply: <Reply className="h-4 w-4 text-green-500" />,
  follow: <UserPlus className="h-4 w-4 text-purple-500" />,
  mention: <MessageCircle className="h-4 w-4 text-blue-500" />,
  subscription_comment: <BellRing className="h-4 w-4 text-amber-500" />,
  subscription_reply: <BellRing className="h-4 w-4 text-amber-500" />,
  direct_message: <Send className="h-4 w-4 text-indigo-500" />,
  group_message: <Users className="h-4 w-4 text-indigo-500" />,
  level_achieved: <TrendingUp className="h-4 w-4 text-indigo-500" />,
  level_reward_earned: <Gift className="h-4 w-4 text-emerald-500" />,
  badge_earned: <Award className="h-4 w-4 text-yellow-500" />,
  default: <Bell className="h-4 w-4 text-gray-500" />,
};

export const getNotificationIcon = (verb) => NOTIFICATION_ICONS[verb] || NOTIFICATION_ICONS.default;
